export const QUESTIONS = 'questions';
export const ITEMS = 'items';
export const PASSAGE = 'passage';
export const COMPREHENSION = 'comprehension';
export const LIGHTNING = 'lightning';
export const MODEL = 'model';
export const MODELING = 'modeling';
export const PRACTICE = 'practice';
export const INSTRUCTIONS = 'instructions';
export const REMINDERS = 'reminders';
export const DIRECTIONS = 'directions';
export const OPENING = 'opening';
export const SCROLL = 'model-scroll';
export const READY = 'ready';
export const COUNTDOWN = 'countdown';
export const READING = 'reading';
export const BOOK = 'book';
export const MODE = {
    ACTIVE: 'active',
    READY: 'ready',
};
